const NS = 'CareerListingBlock';
const CLS = 'careerListingBlock';
import Handlebars from 'handlebars';
import { CareerItemWidget } from '../../../widgets/careerItemWidget/js/careerItemWidget';
import { spinnerService } from '../../../../global/js/wlc/spinnerService';

export class CareerListingBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.spinnerService = spinnerService;

		this.siteId = this.$element.data('siteId');
		this.pageSize = this.$element.data('pageSize');
		this.getApi = this.$element.data('getItemsApi');
		this.getDetailsApi = this.$element.data('getItemDetails');
		this.results = this.$element.data('results');
		this.readmore = this.$element.data('readmore');
		this.emptyMessage = this.$element.data('emptyMessage');
		this.$mainContent = this.$element.find(`.${CLS}-mainContent`);
		this.$filterKeys = this.$element.find(`[data-filter-key]`);
		this.$searchInp = this.$element.find(`.${CLS}-searchInput`);
		this.$regions = this.$element.find(`#regions`);
		this.$initText = this.$element.find(`.initText`);
		this.$pillar = this.$element.find(`#pillar`);
		this.$searchFilterBtn = this.$element.find(`.${CLS}-filterBtnSearch`);
		this.$clearFilterBtn = this.$element.find(`.${CLS}-filterBtnClear`);
		this.$leftcln = this.$element.find(`.${CLS}-left`);
		this.$rightcln = this.$element.find(`.${CLS}-right`);
		this.$resultsHtml = this.$element.find(`.${CLS}-results`);
		this.$noResultsHtml = this.$element.find(`.noResults`);
		this.$careerListingBlockPagination =  this.$element.find(`.careerListingBlock-pagination`);
		this.$paginationLoadMore = this.$element.find(`.pagination-load-more`);

		var url_string = window.location.href; 
		var url = new URL(url_string);
		this.$urlRegions = url.searchParams.get("regions");
		this.$urlPillar = url.searchParams.get("pillar");
		this.$urlJobId = url.searchParams.get("jobId");
		this.isFilterPopulated = false;
		this.pageNumber = 1;
		
		this.params = {
			siteId: this.siteId,
			offset: 0,
			pageSize: this.pageSize,
			keyword: this.$searchInp.val() || '',
			pillar: this.$urlPillar || '',
			jobId: this.$urlJobId || ''
		};
		this.$mainContent.css('display','none');
		this.setItemTemplate();
		this.getItems();
		this.handleSearchButton();
		this.handleFilterClearBtn();
		this.initFilterKeys();
		this.handleJobdetails();

		this.$paginationLoadMore.on('click', () => {
			this.pageNumber++;
			this.setPageNumber(this.pageNumber);
			this.getItems(true);
		});

		if(this.$urlJobId !== ''){
			this.$mainContent.css('display','block');
			this.$initText.css('display','none');
			this.getJobDetails(this.$urlJobId, this.$siteId);
		}
	}
	initParams(clear) {
		if(clear){
			this.params = {
				siteId: this.siteId,
				offset: 0,
				pageSize: this.pageSize,
				regions: '',
				pillar: '',
				keyword: '',
				jobId: ''
			};
		}
		else{
			this.params = {
				pageId: this.pageId,
				offset: 0,
				pageSize: this.pageSize,
				regions: this.$urlRegions || '',
				pillar: this.$urlPillar || '',
				keyword: this.$searchInp.val() || '',
				jobId: this.$urlJobId || ''
			};
		}
	}
	getItems(isLoadMore = false) {
		// URL Params
		
		let url = this.getApi;
		if(!_.isEmpty(this.params)) {
			url += `?${$.param(this.params)}`;
		}
		if (!isLoadMore) {
			this.$resultsHtml.empty();
		}
		else{
			this.setPageNumber(this.pageNumber);
			this.$paginationLoadMore.addClass('active');
		}
		// Display spinner
		this.$leftcln.css('display','block');
		this.$rightcln.css('display','block');
		this.spinnerService.appendTo();
		this.updateUrl();

		// Fetch data
		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				
				if(!this.isFilterPopulated){
					if(this.$urlRegions !== null){
						data.filters.regions.forEach((item) => {
							if(this.$urlRegions.includes(item)){
								this.$regions.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+item+`'">`+item+`</option>`);
							}
							else{
								this.$regions.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
							}
						});
					}
					else{
						data.filters.regions.forEach((item) => {
							this.$regions.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
						});
					}
					if(this.$urlPillar !== null){
						data.filters.careerPillar.forEach((item) => {
							if(this.$urlPillar.includes(item)){
								this.$pillar.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' selected value='`+item+`'">`+item+`</option>`);
							}
							else{
								this.$pillar.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
							}
						});
					}
					else{
						data.filters.careerPillar.forEach((item) => {
							this.$pillar.append(`<option class='`+CLS+`-filters-dropdown-item dropdown-item' value='`+item+`'">`+item+`</option>`);
						});
					}
					this.isFilterPopulated = true;
					this.$regions.selectpicker('refresh');
					this.$pillar.selectpicker('refresh');
				}

				let items = data.jobs;
				
				if(items.length > 0) {
					this.$noResultsHtml.hide();
					items.forEach((item) => {
						let itemMarkup = this.itemTemplate(item);
						this.$resultsHtml.append(`
							${itemMarkup}
						`);
		
						new CareerItemWidget(this.$resultsHtml.find('.careerItemWidget').last()[0]);
					});
					if(data.totalCount > 0){
						this.getJobDetails(data.jobs[0].jobId, this.siteId);
						this.updatePaginationInfo(items.length, data.totalCount);
					}
					if (items.length < this.params.pageSize) {			
						this.$paginationLoadMore.hide();
					} else {
						this.$paginationLoadMore.show();
					}
				}
				else {
					// No results
					this.$noResultsHtml.show();
					this.$initText.css('display','none');
					this.$paginationLoadMore.hide();
					this.$leftcln.css('display','none');
					this.$rightcln.css('display','none');
				}

				// Remove spinner
				this.spinnerService.removeFrom();
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) { 
				console.log("Status: " + textStatus, "Error: " + errorThrown);
			} 
		});
	}

	// Update url after filters change
	updateUrl() {
		let url = new URL(window.location.href);	
		for (let [key, value] of Object.entries(this.params)) {
			if (value === undefined) {
				url.searchParams.delete(key);
			} else {
				url.searchParams.set(key, this.params[key]);
			}
		}

		window.history.pushState({}, '', url.toString());
	}

	updatePaginationInfo(currentResultsCount, totalResultsCount) {		
			const totalShownResults = ((this.pageNumber-1) * this.params.pageSize) + currentResultsCount;
		}
	
	setItemTemplate() {
			let mediaItemPartial = require('../../../widgets/careerItemWidget/tmpl/careerItemWidget.hbs');
			Handlebars.registerPartial('careerItemWidget', mediaItemPartial);
	
			let template = `
				{{> careerItemWidget
					wg="careerItemWidget"
					ns="CareerItemWidget"
				}}
			`;
			let precompiled = new Function('return ' + Handlebars.precompile(template))();
			this.itemTemplate = Handlebars.template(precompiled);
	}

	handleSearchButton() {
		this.$searchFilterBtn.on('click', () => {
			this.$mainContent.css('display','block');
			this.$initText.css('display','none');
			this.params['keyword'] = this.$searchInp.val().trim();
			this.setPageNumber(1);
			this.getItems(false);
		});
	}

	// Clear button
	handleFilterClearBtn() {
		this.$clearFilterBtn.on('click', () => {
			// set 1 to let initParams know it's coming from clear btn
			this.initParams(1);
			this.updateUrl();
			window.scrollTo(0, 0);
			this.$regions.selectpicker('val', '');
			this.$pillar.selectpicker('val', '');
			$(".selectpicker").selectpicker('deselectAll');
			//this.getItems(false);
			this.$searchInp.val('');
			this.$mainContent.css('display','none');
			this.$initText.css('display','block');
			$('.careerListingBlock-jobDetail').empty();
			$('.careerListingBlock-results').empty();
			this.$resultsHtml.empty();
		});
	}

	handleFilterClick($element) {
		let filterKey = $element.data('filterKey') || '';
		let value = [];
		value.push($element.val());
		this.$element.find(`[data-filter-key="${filterKey}"]`).removeClass('active');
		$element.addClass('active');
		if(!(_.isNil(this.params[filterKey]) && value === '')) {
			if(this.params[filterKey] !== value) {
				if(_.isNil(value) || value === '') {
					delete this.params[filterKey];
				}
				else {
					this.params[filterKey] = value.toString();
				}
				this.setPageNumber(1);
				this.getItems(false);
			}
		}
	}

	// initialise the filter keys
	initFilterKeys() {
		this.$filterKeys.on('change', (event) => {
			this.$mainContent.css('display','block');
			this.$initText.css('display','none');
			let $element = $(event.currentTarget);
			this.handleFilterClick($element);
		});

	}
	setPageNumber(newPageNumber) {
		this.pageNumber = newPageNumber;
		this.params.offset = (this.pageNumber - 1) * this.pageSize;
	}

	handleJobdetails() {
		this.$resultsHtml.on('click', '.careerItemWidget', (event) => {
			let jobId = $(event.currentTarget).data('id'); 
			this.getJobDetails(jobId, this.siteId);

			if (window.innerWidth <= 768) {
				$('.careerListingBlock-right').addClass('active'); 
				$('.careerListingBlock-left').hide();
			}
		});
		$(document).on('click', '.careerListingBlock-backBtn', () => {
			$('.careerListingBlock-right').removeClass('active'); 
			$('.careerListingBlock-left').show();
		});
	}
	getJobDetails(jobId, siteId) {
		if (jobId){
			let detailUrl = this.getDetailsApi+`?jobid=${jobId}&siteid=${siteId}`; 
			this.spinnerService.appendTo();
			$.ajax({
				type: 'GET',
				url: detailUrl,
				success: (data) => {
					this.renderJobDetails(data);
				},
				error: (err,data) => {
					console.error("Error fetching job details:", err);
				}
			});
		}
		else{
			return;
		}
	}
	renderJobDetails(data) {
		if (!data) return;
		this.spinnerService.removeFrom();
		let coursesHtml = '';
		if (Array.isArray(data.relevantCourses) && data.relevantCourses.length > 0) {
			coursesHtml += '<h5><strong>Relevant Courses:</strong></h5>';
			data.relevantCourses.forEach(course => {
				coursesHtml += `<a class='relevantCourses' href="${course.courseLink}" target="_blank">${course.courseTitle}</a>`;
			});
		}
		let detailHtml = `
			<div class="jobDetail">
				<h2>${data.role}</h2>
				<p>${data.description}</p><br>
				<h5><strong>Career Pillar:</strong> ${data.careerPillar}</h5>
				<h5><strong>Lifecycle:</strong> ${data.lifecycle}</h5>
				<h5><strong>Regions:</strong> ${data.regions}</h5>
				${coursesHtml}
			</div>
		`;
	
		$('.careerListingBlock-jobDetail').html(detailHtml);
	}
}
